module.exports = {"360121001":"八月湖街道","360121100":"莲塘镇","360121101":"向塘镇","360121102":"三江镇","360121103":"塘南镇","360121104":"幽兰镇","360121105":"蒋巷镇","360121106":"武阳镇","360121107":"冈上镇","360121108":"广福镇","360121191":"昌东镇（南昌高新开发区）","360121192":"麻丘镇（南昌高新开发区）","360121200":"泾口乡","360121201":"南新乡","360121202":"塔城乡","360121203":"黄马乡","360121204":"富山乡","360121205":"东新乡","360121206":"八一乡","360121403":"小蓝经济开发区","360121471":"南昌县银三角管理委员会","360121501":"鲤鱼洲管理处（南昌高新开发区）","360121572":"江西省良种繁殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360121.json
// module id = 1252
// module chunks = 0